import { render } from "./PrototypeTileComponent.vue?vue&type=template&id=314f3d1c&scoped=true&ts=true"
import script from "./PrototypeTileComponent.vue?vue&type=script&lang=ts"
export * from "./PrototypeTileComponent.vue?vue&type=script&lang=ts"

import "./PrototypeTileComponent.vue?vue&type=style&index=0&id=314f3d1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314f3d1c"]])

export default __exports__